import React from "react";
import { useContactBadge } from "./useContactBadge";

/**
 * La pastille rouge « Contact Messages (N) » de la barre latérale. N = les messages de contact au
 * statut « new », vivant via {@link useContactBadge}. Ne rend rien à zéro. Dans la barre repliée,
 * elle se réduit à un point rouge sur l'icône.
 */
export const ContactNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
	const count = useContactBadge();
	if (count <= 0) return null;
	if (collapsed) {
		return (
			<span
				className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-rose-500 ring-2 ring-white"
				aria-label={`${count} nouveaux messages`}
			/>
		);
	}
	return (
		<span className="ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-xs font-bold text-white">
			{count}
		</span>
	);
};

export default ContactNavBadge;
